import { Component, ChangeDetectionStrategy, OnInit, Input } from '@angular/core';
import { ComponentCanDeactivate } from '../../../../helpers/can-deactivate-helpers';
import { Observable, of, combineLatest } from 'rxjs';
import { UIFacade, DataStoreFacade } from '../../../../facades';
import { map } from 'rxjs/operators';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EditorSpaceplanTemplateFacade } from 'src/app/spaceplan/shared/facades/editor-spaceplan-template.facade';

@Component({
  selector: 'app-editor-spaceplan-template',
  styleUrls: ['./editor-spaceplan-template.component.scss'],
  templateUrl: './editor-spaceplan-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorSpacePlanTemplateComponent {
  @Input()
  public headerVisible = true;
  @Input()
  public canClose = true;
  public form: FormGroup;
  public isRequesting = false;
  public options$ = combineLatest([this.dataStoreFacade.partners$, this.dataStoreFacade.folders$, of(false)]).pipe(
    map(([partners, folders, isReadOnly]) => {
      return {
        partners,
        folders,
        readOnly: isReadOnly,
      };
    })
  );

  constructor(
    public editorFacade: EditorSpaceplanTemplateFacade,
    public dataStoreFacade: DataStoreFacade,
    private fb: FormBuilder,
    public uiFacade: UIFacade
  ) {
    this.form = this.fb.group({});
  }

  onSubmit() {
    this.isRequesting = true;
    if (!this.form.invalid) {
      this.uiFacade.showLoading();
      this.editorFacade.save().subscribe(
        (result) => {
          if (result.success) {
            // SAVE SUCESS
            this.form.markAsUntouched();
            this.form.markAsPristine();
            this.isRequesting = false;
            this.uiFacade.hideLoading();
          }
        },
        (err) => {
          this.uiFacade.hideLoading();
        }
      );
    }
  }
  onClose() {
    this.editorFacade.close();
  }
}
